module.exports = __webpack_public_path__ + "components/tooltips/static/rainfall-73092f1ecad893748af3da03ab17358f.jpg";